var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "table" }, [
    _c(
      "div",
      { staticClass: "container" },
      [
        _c(
          "div",
          { staticClass: "handle-box" },
          [
            _c(
              "el-form",
              {
                ref: "queryCondition",
                staticClass: "searchForm",
                attrs: {
                  model: _vm.queryCondition,
                  "label-position": "right",
                  "label-width": "120px",
                },
              },
              [
                _c(
                  "el-row",
                  { attrs: { gutter: 20 } },
                  [
                    _c(
                      "el-col",
                      { attrs: { span: 6 } },
                      [
                        _c(
                          "el-form-item",
                          { attrs: { label: "制成大类", prop: "categoryId" } },
                          [
                            _c(
                              "el-select",
                              {
                                attrs: { filterable: "" },
                                model: {
                                  value: _vm.queryCondition.categoryId,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.queryCondition,
                                      "categoryId",
                                      $$v
                                    )
                                  },
                                  expression: "queryCondition.categoryId",
                                },
                              },
                              _vm._l(
                                _vm.categoryOptions,
                                function (item, index) {
                                  return _c("el-option", {
                                    key: index,
                                    attrs: {
                                      label: item.label,
                                      value: item.value,
                                    },
                                  })
                                }
                              ),
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      { attrs: { span: 6 } },
                      [
                        _c(
                          "el-form-item",
                          { attrs: { label: "制成编码", prop: "processCode" } },
                          [
                            _c("el-input", {
                              staticStyle: { width: "100%" },
                              attrs: { clearable: "" },
                              model: {
                                value: _vm.queryCondition.processCode,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.queryCondition,
                                    "processCode",
                                    $$v
                                  )
                                },
                                expression: "queryCondition.processCode",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      { attrs: { span: 6 } },
                      [
                        _c(
                          "el-form-item",
                          { attrs: { label: "制成名称", prop: "processName" } },
                          [
                            _c("el-input", {
                              staticStyle: { width: "100%" },
                              attrs: { clearable: "" },
                              model: {
                                value: _vm.queryCondition.processName,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.queryCondition,
                                    "processName",
                                    $$v
                                  )
                                },
                                expression: "queryCondition.processName",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      { attrs: { span: 6 } },
                      [
                        _c(
                          "el-form-item",
                          { attrs: { label: "状态", prop: "status" } },
                          [
                            _c("ic-select", {
                              staticStyle: { width: "100%" },
                              attrs: {
                                table: "TT_PROC",
                                field: "STATUS",
                                clearable: "",
                              },
                              model: {
                                value: _vm.queryCondition.status,
                                callback: function ($$v) {
                                  _vm.$set(_vm.queryCondition, "status", $$v)
                                },
                                expression: "queryCondition.status",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-row",
                  {
                    attrs: { type: "flex", justify: "center", align: "middle" },
                  },
                  [
                    _c(
                      "el-button",
                      {
                        attrs: { size: "mini", type: "primary" },
                        on: { click: _vm.onSearch },
                      },
                      [_vm._v("查询")]
                    ),
                    _c(
                      "el-button",
                      {
                        attrs: { size: "mini", type: "primary" },
                        on: { click: _vm.onReset },
                      },
                      [_vm._v("重置")]
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        ),
        _c(
          "el-row",
          { staticClass: "action-btn-row" },
          [
            _vm.isDialog
              ? _c(
                  "el-button",
                  {
                    staticClass: "btn",
                    attrs: { size: "mini", type: "primary" },
                    on: { click: _vm.onConfirm },
                  },
                  [_vm._v("确认")]
                )
              : _vm._e(),
            _vm.isDialog
              ? _c(
                  "el-button",
                  { attrs: { size: "mini" }, on: { click: _vm.onCancel } },
                  [_vm._v("取消")]
                )
              : _vm._e(),
            !_vm.isDialog
              ? _c(
                  "el-button",
                  {
                    directives: [
                      {
                        name: "acl",
                        rawName: "v-acl",
                        value: _vm.PROC_PROCESS_MANAGE_MAINTAIN,
                        expression: "PROC_PROCESS_MANAGE_MAINTAIN",
                      },
                    ],
                    staticClass: "btn",
                    attrs: { size: "mini", type: "primary" },
                    on: { click: _vm.onAddProcess },
                  },
                  [_vm._v("新增制成")]
                )
              : _vm._e(),
            !_vm.isDialog
              ? _c(
                  "el-button",
                  {
                    directives: [
                      {
                        name: "acl",
                        rawName: "v-acl",
                        value: _vm.PROC_PROCESS_MANAGE_MAINTAIN,
                        expression: "PROC_PROCESS_MANAGE_MAINTAIN",
                      },
                    ],
                    staticClass: "btn",
                    attrs: { size: "mini", type: "primary" },
                    on: { click: _vm.onAddCategory },
                  },
                  [_vm._v("新增大类")]
                )
              : _vm._e(),
            !_vm.isDialog
              ? _c(
                  "el-button",
                  {
                    directives: [
                      {
                        name: "acl",
                        rawName: "v-acl",
                        value: _vm.PROC_PROCESS_MANAGE_MAINTAIN,
                        expression: "PROC_PROCESS_MANAGE_MAINTAIN",
                      },
                    ],
                    staticClass: "btn",
                    attrs: { size: "mini", type: "danger" },
                    on: { click: _vm.onBatchDel },
                  },
                  [_vm._v("批量删除")]
                )
              : _vm._e(),
          ],
          1
        ),
        _c(
          "el-row",
          [
            _c(
              "el-table",
              {
                staticStyle: { width: "100%" },
                attrs: {
                  data: _vm.tableData,
                  "max-height": "425",
                  border: "",
                  stripe: "",
                },
                on: { "selection-change": _vm.handleSelectionChange },
              },
              [
                _c("el-table-column", {
                  attrs: { type: "selection", width: "55" },
                }),
                _c("el-table-column", {
                  attrs: {
                    prop: "categoryId",
                    sortable: "",
                    "sort-method": (a, b) =>
                      _vm.sortMethods(a, b, "categoryId"),
                    label: "制成大类",
                    "min-width": "180",
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _vm._v(
                            " " +
                              _vm._s(
                                scope.row.categoryCode && scope.row.categoryName
                                  ? scope.row.categoryCode +
                                      "-" +
                                      scope.row.categoryName
                                  : ""
                              ) +
                              " "
                          ),
                        ]
                      },
                    },
                  ]),
                }),
                _c("el-table-column", {
                  attrs: {
                    prop: "processCode",
                    sortable: "",
                    "sort-method": (a, b) =>
                      _vm.sortMethods(a, b, "processCode"),
                    label: "制成编码",
                    "min-width": "120",
                    "show-overflow-tooltip": "",
                  },
                }),
                _c("el-table-column", {
                  attrs: {
                    prop: "processName",
                    sortable: "",
                    "sort-method": (a, b) =>
                      _vm.sortMethods(a, b, "processName"),
                    label: "制成名称",
                    "min-width": "250",
                    "show-overflow-tooltip": "",
                  },
                }),
                _c("el-table-column", {
                  attrs: {
                    prop: "processDesc",
                    sortable: "",
                    "sort-method": (a, b) =>
                      _vm.sortMethods(a, b, "processDesc"),
                    label: "制成描述",
                    "min-width": "250",
                    "show-overflow-tooltip": "",
                  },
                }),
                _c("el-table-column", {
                  attrs: {
                    prop: "status",
                    sortable: "",
                    "sort-method": (a, b) => _vm.sortMethods(a, b, "status"),
                    label: "状态",
                    "min-width": "100",
                    "show-overflow-tooltip": "",
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _c(
                            "el-tag",
                            {
                              attrs: {
                                type:
                                  scope.row.status === "ACTIVE"
                                    ? "success"
                                    : "danger",
                              },
                            },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    scope.row.status === "ACTIVE"
                                      ? "启用"
                                      : "禁用"
                                  ) +
                                  " "
                              ),
                            ]
                          ),
                        ]
                      },
                    },
                  ]),
                }),
                !_vm.isDialog
                  ? _c("el-table-column", {
                      attrs: { label: "操作", width: "160" },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _c(
                                  "el-button",
                                  {
                                    directives: [
                                      {
                                        name: "acl",
                                        rawName: "v-acl",
                                        value: _vm.PROC_PROCESS_MANAGE_MAINTAIN,
                                        expression:
                                          "PROC_PROCESS_MANAGE_MAINTAIN",
                                      },
                                    ],
                                    attrs: { type: "primary", size: "small" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.handleEdit(scope.row)
                                      },
                                    },
                                  },
                                  [_vm._v("编辑")]
                                ),
                                _c(
                                  "el-button",
                                  {
                                    directives: [
                                      {
                                        name: "acl",
                                        rawName: "v-acl",
                                        value: _vm.PROC_PROCESS_MANAGE_MAINTAIN,
                                        expression:
                                          "PROC_PROCESS_MANAGE_MAINTAIN",
                                      },
                                    ],
                                    attrs: { type: "danger", size: "small" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.handleDelete(scope.row)
                                      },
                                    },
                                  },
                                  [_vm._v("删除")]
                                ),
                              ]
                            },
                          },
                        ],
                        null,
                        false,
                        2306847781
                      ),
                    })
                  : _vm._e(),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "pagination" },
              [
                _c("el-pagination", {
                  attrs: {
                    "current-page": _vm.queryCondition.pageNum,
                    "page-sizes": _vm.pageSizeList,
                    "page-size": _vm.queryCondition.pageSize,
                    layout: _vm.pageLayout,
                    total: _vm.totalCount,
                    "page-count": _vm.pages,
                  },
                  on: {
                    "size-change": _vm.handleSizeChange,
                    "current-change": _vm.handleCurrentChange,
                  },
                }),
              ],
              1
            ),
          ],
          1
        ),
        _c(
          "el-dialog",
          {
            attrs: {
              title: _vm.dialogTitle,
              visible: _vm.dialogVisible,
              width: "30%",
              "close-on-click-modal": false,
            },
            on: {
              "update:visible": function ($event) {
                _vm.dialogVisible = $event
              },
              close: _vm.onClose,
            },
          },
          [
            _c(
              "el-form",
              {
                ref: "formData",
                attrs: {
                  model: _vm.formData,
                  rules: _vm.formRules,
                  "label-width": "90px",
                },
              },
              [
                _vm.formData.itemType === "process"
                  ? _c(
                      "el-form-item",
                      { attrs: { label: "制成大类", prop: "categoryId" } },
                      [
                        _c(
                          "el-select",
                          {
                            staticStyle: { width: "100%" },
                            attrs: { filterable: "" },
                            model: {
                              value: _vm.formData.categoryId,
                              callback: function ($$v) {
                                _vm.$set(_vm.formData, "categoryId", $$v)
                              },
                              expression: "formData.categoryId",
                            },
                          },
                          _vm._l(_vm.categoryOptions, function (item, index) {
                            return _c("el-option", {
                              key: index,
                              attrs: { label: item.label, value: item.value },
                            })
                          }),
                          1
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
                _c(
                  "el-form-item",
                  { attrs: { label: "编码", prop: "code" } },
                  [
                    _c("el-input", {
                      attrs: { disabled: "" },
                      model: {
                        value: _vm.formData.code,
                        callback: function ($$v) {
                          _vm.$set(_vm.formData, "code", $$v)
                        },
                        expression: "formData.code",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  { attrs: { label: "名称", prop: "name" } },
                  [
                    _c("el-input", {
                      attrs: {
                        placeholder:
                          _vm.formData.itemType === "category"
                            ? "请输入大类名称"
                            : "请输入制成名称",
                        maxlength: "50",
                        "show-word-limit": "",
                      },
                      model: {
                        value: _vm.formData.name,
                        callback: function ($$v) {
                          _vm.$set(_vm.formData, "name", $$v)
                        },
                        expression: "formData.name",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  { attrs: { label: "描述", prop: "desc" } },
                  [
                    _c("el-input", {
                      attrs: {
                        type: "textarea",
                        rows: 3,
                        placeholder:
                          _vm.formData.itemType === "category"
                            ? "请输入大类描述"
                            : "请输入制成描述",
                        maxlength: "500",
                        "show-word-limit": "",
                      },
                      model: {
                        value: _vm.formData.desc,
                        callback: function ($$v) {
                          _vm.$set(_vm.formData, "desc", $$v)
                        },
                        expression: "formData.desc",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  { attrs: { label: "状态", prop: "status" } },
                  [
                    _c("ic-select", {
                      staticStyle: { width: "100%" },
                      attrs: {
                        table: "TT_PROC",
                        field: "STATUS",
                        disabled: _vm.operationType == "add",
                        clearable: "",
                      },
                      model: {
                        value: _vm.formData.status,
                        callback: function ($$v) {
                          _vm.$set(_vm.formData, "status", $$v)
                        },
                        expression: "formData.status",
                      },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
            _c(
              "el-row",
              { attrs: { type: "flex", justify: "center" } },
              [
                _vm.formData.itemType === "process"
                  ? _c(
                      "el-button",
                      {
                        staticClass: "btn",
                        attrs: {
                          size: "mini",
                          type: "primary",
                          disabled: _vm.isSaveDisabled,
                          loading: _vm.isSaveLoading,
                        },
                        on: { click: _vm.onSaveProcess },
                      },
                      [_vm._v("确定")]
                    )
                  : _c(
                      "el-button",
                      {
                        staticClass: "btn",
                        attrs: {
                          size: "mini",
                          type: "primary",
                          disabled: _vm.isSaveDisabled,
                          loading: _vm.isSaveLoading,
                        },
                        on: { click: _vm.onSaveCategory },
                      },
                      [_vm._v("确定")]
                    ),
                _c(
                  "el-button",
                  {
                    staticClass: "btn",
                    attrs: { size: "mini", type: "primary" },
                    on: { click: _vm.onClose },
                  },
                  [_vm._v("取消")]
                ),
              ],
              1
            ),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }